import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, TextField, Button } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import { SelectWithLabel } from '../../utils/selectWithLabel';
import { updateInventory ,getInventoryChoices} from '../../store/inventoryUpdater'
import { FlightItem, RadioDOTW, StatusDisplay } from './inventoryComponents'
import _ from 'lodash';
import { setAirline } from '../../store/inventoryUpdater';
import { updateInventoryRequested } from '../../store/inventoryUpdater';

let screenWidth = window.innerWidth

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  bottomInputs: {
    width: '95%',
    marginRight: '5px',
    border: '1px solid #b5aeae',
    borderRadius: '8px',
    maxHeight: '50px'
  },
  radio: {
    marginRight: '5px'
  },
  dotwButton: {
    backgroundColor: '#66c7a6',
    color: 'white',
    height: '28px'
  },
  paper: {
    position: 'absolute',
    width: '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  tableCellLessPad: {
    padding: '6px'
  }
}));

let daysOfTheWeekArr = [
  {day: 'Monday', checked: false},
  {day: 'Tuesday', checked: false},
  {day: 'Wednesday', checked: false},
  {day: 'Thursday', checked: false},
  {day: 'Friday', checked: false},
  {day: 'Saturday', checked: false},
  {day: 'Sunday', checked: false}
]

// NOTE // they had some duplicates which throws a wrench in SelectWithLabel, so added some descriptors with '&' ('&' is ignored when setting course)
const inventoryChoices = [
  {label: 'Custom', value: 'You found the easter egg!'},
  {label: 'Carib. High', value: 'CARIBHIGH&YZ0:0,YX0:0,YE0:0,YY0:0,YR0:0,YB8:8,YM0:0,YQ0:0,YK0:0,YV0:0'},
  {label: 'Carib. Low', value: 'YZ0:0,YX0:0,YE0:0,YY0:0,YR0:0,YB0:0,YM0:0,YQ0:0,YK8:8,YV0:0'},
  {label: 'Carib. Med', value: 'YZ0:0,YX0:0,YE0:0,YY0:0,YR0:0,YB0:0,YM0:0,YQ8:8,YK0:0,YV0:0'},
  {label: 'Carib. Outside 3 Months of Flight', value: 'CARIBOUT&YZ0:0,YX0:0,YE0:0,YY0:0,YR0:0,YB8:8,YM0:0,YQ0:0,YK0:0,YV0:0,YP0:0'},
  {label: 'Carib. Within 3 Months of Flight', value: 'YZ0:0,YX0:0,YE0:0,YY4:4,YR4:4,YB0:0,YM0:0,YQ0:0,YK0:0,YV0:0,YP0:0'},
  {label: 'NE With Reverse', value: 'NE&YZ0:0,YX0:0,YE0:0,YC0:0,YY0:0,YV8:8,YP0:0,YD0:0'},
  {label: 'NE Without Reverse', value: 'YZ0:0,YX0:0,YE0:0,YC0:0,YY8:8,YP0:0,YT0:0'},
  {label: 'PL2b', value: 'YY8:8'},
  {label: 'Zero', value: 'YY0:0'},
]

// NOTE // input format: YYYY-MM-DD, output format: DDMMMYY
const formatDate = (date) => {
  let day = date.slice(8)
  let month = date.slice(5, 7)
  let year = date.slice(2, 4)
  let monthsArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  month = monthsArr[Number(month) - 1]
  return `${day + month + year}`.toUpperCase()
}
function formatDateForAvs(inputDate) {
  const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

  const parts = inputDate.split('-');
  const year = parts[0];
  const monthIndex = parseInt(parts[1]) - 1; // Adjusting month index to start from 0
  const day = parts[2];

  // Construct the output date string
  const formattedDate = `${day}-${months[monthIndex]}-${year}`;
  
  return formattedDate;
}


export default function  InventoryUpdater(props) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const [newFlight, setNF] = useState('')
  const [flights, setFlights] = useState([])
  const [origin, setOrigin] = useState('')
  const [dest, setDest] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [daysOfTheWeek, setDotw] = useState(daysOfTheWeekArr)
  const [inventory, setInventory] = useState('You found the easter egg!')
  const[getSeatPlan,setSeatPlan]=useState('');
  const [course, setCourse] = useState('')
  const [courseDisabled, setCD] = useState(false)
  const [error, setError] = useState('')
  const status = useSelector(state => state.entities.inventory.status)
  const [dynamicInventoryChoices, setDynamicInventoryChoices] = useState([]);
  const inventoryChoices=useSelector(state=>state.entities.inventory.inventory);
  const response = useSelector(state => state.entities.inventory.response);

  const handleInventory = (data) => {
    setInventory(data);
     setError('');
    setSeatPlan(data.split('-')[0]);
    console.log(course);
    console.log(data);
    if (data.includes('&')) {
      setCourse(data.split('&')[1])
      setCD(true)
    }
    else if (data === 'CUSTOM--7') {
      setCourse(course)
      setCD(false)
    }
    else {
      const selectedItem = dynamicInventoryChoices.find((choice) => choice.id === data);
        setCourse(selectedItem.value);
        setCD(true);
    }
  }


const handleChangeDOTW = (input) => {
  // NOTE // dotw buttons
  let dotwCopy = _.cloneDeep(daysOfTheWeek)
  if (input === 'All') {
    dotwCopy = dotwCopy.map(dayObj => { return { day: dayObj.day, checked: true } })
  }
  else if (input === 'MTWTF') {
    // NOTE // check all the days that don't start with S
    dotwCopy = dotwCopy.map(dayObj => {
      return dayObj.day.slice(0, 1) !== 'S' ? { day: dayObj.day, checked: true } : { day: dayObj.day, checked: false }
    })
  }
  else if (input === 'Clear') {
    dotwCopy = _.cloneDeep(daysOfTheWeekArr)
  }
  // NOTE // dotw checkboxes
  else {
    let dayLoc = dotwCopy.findIndex(dayObj => dayObj.day === input)
    dotwCopy[dayLoc].checked = !dotwCopy[dayLoc].checked
  }

  setDotw(dotwCopy)
}

// NOTE // checks if the new flight is 3-4 digits and doesn't already exist in flights
const handleNewFlight = () => {
  let flightsCopy = _.cloneDeep(flights)
  if (newFlight) {
    if (newFlight.length > 4 || newFlight.length < 3 || isNaN(Number(newFlight)) || flights.includes(newFlight)) {
      setError(': New flights must be a 3 to 4 digit number')
    }
    else {
      flightsCopy.push(newFlight)
      setFlights(flightsCopy)
      setNF('')
    }
  }
  else {
    setError(': New flights must be a 3 to 4 digit number')
  }
}
//KEYPRESS EVENT IN ADD BUTTON
const handle_Submit = (e) => {
  e.preventDefault();
  handleNewFlight();
};

// NOTE // passing this to FlightItem so you can remove a flight from the flights box
const removeFlight = (index) => {
  let flightsCopy = _.cloneDeep(flights)
  flightsCopy.splice(index, 1)
  setFlights(flightsCopy)
}

const handleSubmit = () => {
  let isValid=false;
  if(getSeatPlan==="CUSTOM")
  {
    const pattern =/^\b([A-Z]{2}[0-9]:[0-9]:[0-9])(,[A-Z]{2}[0-9]:[0-9]:[0-9])*\b$/;
    isValid= pattern.test(course);
    console.log(isValid);
  }
  else
  {
    isValid=true;
  }
  // NOTE // need something in all inputs, origin and dest need to be iata (i.e. BOI)
  if (origin && dest && origin.length === 3 && dest.length === 3 && startDate && endDate && course && flights.length > 0 && daysOfTheWeek.length > 0 && isValid) {
   if(endDate<startDate)
    {
      setError('The End Date Must be greater than or equal to Start Date');
    }
    else
    {
    setError('')
    // NOTE // commandStr will be the final output with each command separated by '|%'
    let commandsStr = ''
    // NOTE // \d{1,7} each digit relates to a day of the week, i.e. 1 = Sunday, 2 = Monday, etc.
    let daysOfTheWeekStr = ''
    // NOTE // looping over daysOfTheWeek and adding the corresponding number if it's checked
    for (let i = 0; i < daysOfTheWeek.length; i++) {
      const day = daysOfTheWeek[i];
      if (day.checked) {
        daysOfTheWeekStr += (i + 1)
      }
    }

    // NOTE // Idk what the U, ^IMD, and IMN are (but they seem to be static)
    // NOTE // example command: 'IMN/TJ299/SVCPHX/07DEC21/07DEC21/1/YZ0:0,YX0:0,YE0:0,YC0:0,YY8:8^IMD/TJ299/SVCPHX/07DEC21/07DEC21/1/U'
    let baseCommand = `IMN/---/${origin.toUpperCase()}${dest.toUpperCase()}/${formatDate(startDate)}/${formatDate(endDate)}/${daysOfTheWeekStr}/${course}\^IMD/---/${origin.toUpperCase()}${dest.toUpperCase()}/${formatDate(startDate)}/${formatDate(endDate)}/${daysOfTheWeekStr}/U`
    let avscommand=`<Command><![CDATA[<xml><zflt command=\"seatplan\" action=\"update\" confirm=\"False\"><filter id=\"0\" city1=\"${origin.toUpperCase()}\" city2=\"${dest.toUpperCase()}\" fltno=\"TJ${flights[0]}\" fltgroup=\"\" start=\"${formatDateForAvs(startDate)}\" stop=\"${formatDateForAvs(endDate)}\" aircrafttype=\"\" mo=\"${daysOfTheWeekStr.includes(1)?1:0}\" tu=\"${daysOfTheWeekStr.includes(2)?1:0}\" we=\"${daysOfTheWeekStr.includes(3)?1:0}\" th=\"${daysOfTheWeekStr.includes(4)?1:0}\" fr=\"${daysOfTheWeekStr.includes(5)?1:0}\" sa=\"${daysOfTheWeekStr.includes(6)?1:0}\" su=\"${daysOfTheWeekStr.includes(7)?1:0}\" /><params><classid /><setnopax>nochange</setnopax><classcap /><agentcap /><autopnl>nochange</autopnl><pnlsent>nochange</pnlsent><pnletkt>nochange</pnletkt><pnlptkt>nochange</pnlptkt><adl>nochange</adl><txpnlhrs /><txpnl2hrs /><avsthreshold /><gdsairline /><txemail /><newclasscabin /><newclassavs /><newflight /><qcity /><qnumber /><qallpnr>0</qallpnr><seatplanname>${getSeatPlan}</seatplanname><overwriteclassconfig>1</overwriteclassconfig></params></zflt></xml>]]></Command>`
    for (let i = 0; i < flights.length; i++) {
      const flt = flights[i];
      let regexTest = /^IMN\/[A-Z]{2}\d{1,6}\/[A-Z]{6}\/\d{2}[A-Z]{3}\d{2}\/\d{2}[A-Z]{3}\d{2}\/\d{1,7}\/[A-Z,:0-9]{3,}\^\IMD\/[A-Z]{2}\d{1,6}\/[A-Z]{6}\/\d{2}[A-Z]{3}\d{2}\/\d{2}[A-Z]{3}\d{2}\/\d{1,7}\/U$/
      let commandCopy = baseCommand
      // NOTE // replace both of the '---'s for each flight
      commandCopy = commandCopy.split('---').join('TJ' + flt)
      // NOTE // if there is a flight after this one, separate it with '|%'
      if (regexTest.test(commandCopy)) {
        commandsStr += (i + 1) < flights.length ? commandCopy + '|%' : commandCopy
      }
      else {
        setError(': One or more flights did not work correctly, please check your data')
      }
    }
      if(getSeatPlan==="CUSTOM")
        {
          dispatch(updateInventory({ commands: commandsStr }));
        }
        else{
        dispatch(updateInventory({ commands: commandsStr,avscommand: avscommand }));
        }
  }
  }

  else { 
    if(!isValid && getSeatPlan==="CUSTOM")
    {
      setError(': Please Enter a Valid Value');
    }
  else{
  setError(': You need an origin and destination city (IATA), a start and end date, a course, at least 1 flight, and at least 1 day of the week to add inventory');
  }
  }
}
useEffect(()=>{
  dispatch(updateInventoryRequested(""));
},[flights,origin,endDate,startDate,dest,inventory,daysOfTheWeek,course])

  useEffect(() => {
    // Dispatch the action when your component mounts
    dispatch(setAirline(props.airline));
    dispatch(getInventoryChoices());
  }, [dispatch, props.airline]);


// Separate the mapping logic into its own function for clarity
  const mapInventoryChoices = (choices) => {
    return choices.map((item, index) => ({
      id: `${item.label}-${item.value}-${index}`, // Create a unique ID using label, value, and index
      label: item.label,
      value: item.value,
    }));
  };

    // Define the desired order
const order = [
  "TEB FULL TICKET",
  "TEB HALF TICKET",
  "HPN FULL TICKET",
  "HPN HALF TICKET",
  "NORTHEAST",
  "NORTHEAST ZERO",
  "CARIBBEAN",
  "CARIBBEAN ZERO",
  "CUSTOM"
];

// Custom sorting function
const sortByCustomOrder = (a, b) => {
  return order.indexOf(a.label) - order.indexOf(b.label);
};

  useEffect(() => {
    // Assuming that inventoryChoices is available (e.g., set by the previous useEffect)
    const data = mapInventoryChoices(inventoryChoices);
    const sortedChoices = data.sort(sortByCustomOrder);
    setDynamicInventoryChoices(sortedChoices);
  }, [inventoryChoices]);




return (
  <div id="inventory-updater" style={{ marginLeft: '15px', marginRight: '15px' }}>
    <Grid container justifyContent="center">
      <Grid container justifyContent="center" item xs={11} md={8} style={{ backgroundColor: 'whitesmoke', height: `${660 + (flights.length > 3 ? (flights.length - 3) * 37 : 0)}px` }}>
        <Grid container item xs={11} style={{ marginBottom: '10px', marginTop: '15px' }}>
          <Grid id="flights-selector" container item xs={12} md={4}>
            <Grid id="selected-flights-box" container justifyContent="center" item xs={12}>
              <div style={{ border: '1px solid black', borderRadius: '7px', minHeight: '120px', width: '90%', marginBottom: '15px' }}>
                {
                  flights.map((flight, index) => (
                    <FlightItem flight={flight} index={index} remove={removeFlight} key={flight + '-' + index} />
                  ))
                }
              </div>
            </Grid>
            <form onSubmit={handle_Submit}>
              <Grid container justifyContent="center" item xs={12} style={{ padding: '13px' }}>
                <Grid container justifyContent="center" item xs={9}>
                  <TextField
                    id="cur-flight-input"
                    placeholder="Add Flight"
                    type="text"
                    value={newFlight}
                    style={{width: '95%'}}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => {setNF(e.target.value)}}
                  />
                </Grid>
                <Grid container justifyContent="center" alignContent="flex-start" item xs={2}>
                  <Button variant="contained" disabled={flights.length>=1} size="small" style={{height: '28px', color: 'white', backgroundColor: 'cadetblue'}} onClick={() => {handleNewFlight()}}>Add</Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
          <Grid id="offset-filler" container item xs={12} md={1} style={{ height: '10px' }}></Grid>
          <Grid id="city-date-days-inputs" container justifyContent="center" item xs={12} md={7}>
            <Grid id="offset-filler-2" container item xs={1} md={12}></Grid>
            <Grid container item xs={5}>
              <TextField
                id="origin-input"
                label="Origin"
                type="text"
                defaultValue={origin}
                style={{ width: '95%', marginRight: '5px' }}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setOrigin(e.target.value)}
              />
            </Grid>
            <Grid container item xs={5}>
              <TextField
                id="dest-input"
                label="Destination"
                type="text"
                defaultValue={dest}
                style={{ width: '95%' }}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setDest(e.target.value)}
              />
            </Grid>
            <Grid id="offset-filler-3" container item xs={1} md={12}></Grid>
            <Grid container item xs={5}>
              <TextField
                id="start-date-input"
                label="Start"
                type="date"
                defaultValue={startDate}
                style={{ width: '95%', marginRight: '5px' }}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Grid>
            <Grid container item xs={5}>
              <TextField
                id="end-date-input"
                label="End"
                type="date"
                defaultValue={endDate}
                style={{ width: '95%' }}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Grid>
            <Grid container item xs={12} style={{ marginTop: '10px' }}>
              <Grid container justifyContent='center' item xs={4}>
                <Button variant="contained" className={classes.dotwButton} onClick={() => { handleChangeDOTW('All') }}>All</Button>
              </Grid>
              <Grid container justifyContent='center' item xs={4}>
                <Button variant="contained" className={classes.dotwButton} onClick={() => { handleChangeDOTW('MTWTF') }}>MTWTF</Button>
              </Grid>
              <Grid container justifyContent='center' item xs={4}>
                <Button variant="contained" className={classes.dotwButton} onClick={() => { handleChangeDOTW('Clear') }}>Clear</Button>
              </Grid>
            </Grid>
            <Grid container justifyContent="center" item xs={12}>
              <RadioDOTW day={daysOfTheWeek[0]} change={handleChangeDOTW} />
              <RadioDOTW day={daysOfTheWeek[1]} change={handleChangeDOTW} />
              <RadioDOTW day={daysOfTheWeek[2]} change={handleChangeDOTW} />
              <RadioDOTW day={daysOfTheWeek[3]} change={handleChangeDOTW} />
              <RadioDOTW day={daysOfTheWeek[4]} change={handleChangeDOTW} />
              <RadioDOTW day={daysOfTheWeek[5]} change={handleChangeDOTW} />
              <RadioDOTW day={daysOfTheWeek[6]} change={handleChangeDOTW} />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          id="inventory-course-submit"
          container justifyContent="center"
          item xs={11}
          style={{ backgroundColor: '#c9c9c9', borderRadius: '2px', marginBottom: '10px', height: '26%', marginTop: screenWidth <= 800 ? '0px' : '20px' }}
        >
          <Grid container justifyContent="center" alignContent="center" item xs={11} md={4}>
            <SelectWithLabel
              defaultVal={inventory}
              handleChange={(e) => { handleInventory(e.target.value) }}
              inputLabel={'Inventory'}
              items={dynamicInventoryChoices.map((choice) => ({
                label: choice.label,
                value: choice.id, // Use the unique ID as the value
              }))}
              customStyle={{
                width: '95%',
                marginRight: '5px',
                border: '1px solid #b5aeae',
                borderRadius: '8px',
                marginTop: '10px',
                backgroundColor: '#efefef',
                maxHeight: '50px'
              }}
            />
          </Grid>
          <Grid id="course-input-container" container justifyContent="center" alignContent="center" item xs={11} md={6} style={{ marginTop: '10px' }}>
            {getSeatPlan!=="CUSTOM"?(
              <TextField
              id="course-input"
              label="Course"
              type="text"
              value={course}
              disabled={courseDisabled}
              className={classes.bottomInputs}
              style={{ backgroundColor: courseDisabled ? '#adadad' : '#efefef' }}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => { setCourse(e.target.value) }}
            />):(
              <TextField
              id="course-input"
              label="Please Enter The Course"
              value={course}
              type="text"
              className={classes.bottomInputs}
              style={{ backgroundColor: '#efefef' }}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => { setCourse(e.target.value) }}/>
            )
            }
          </Grid>
          <Grid container justifyContent="center" alignContent="center" item xs={11} md={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
            <Button
              variant="contained"
              style={{ textDecoration: 'none', textTransform: 'none', height: '28px', color: '#fff', backgroundColor: '#337ab7', borderColor: '#1f527e' }}
              onClick={() => { handleSubmit() }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
        <Grid container justifyContent="center" item xs={12} id="error-display" style={{ color: 'red' }}>
          <span style={{ fontWeight: 'bold' }}>{error ? 'Error' : ''}</span>{error}
        </Grid>
        <Grid container justifyContent="center" item xs={12} id="status-display">
        {Object.keys(response).length > 0 ? (
  <StatusDisplay status={status} response={response} />
) : (
  <StatusDisplay status={status} />
)}        </Grid>
      </Grid>
    </Grid>
  </div>
)
}